import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "./css/Navbar.css"; // Assuming CSS is moved here

const navLinks = [
  {
    to: "/",
    label: "Top UK Schools 2025",
    ariaLabel: "Top UK Schools 2025",
    //tooltip: "(Last update: 20/10/2025, next update: 30/10/2025. Updated England 2025.)",
  },
  {
    to: "/guidance",       // NEW: route to your GuidancePage
    label: "Guidance",      // What users will see
    ariaLabel: "How to use the site", 
  },
  // {
  //   to: "/upload",
  //   label: "Upload & Create Chart",
  //   ariaLabel: "Upload and create school chart",
  // },
  {
    to: "/dashboard",
    label: "NI Budget Dashboard",
    ariaLabel: "Northern Ireland Budget Dashboard",
  },
];

const Navbar = () => {
  const [nearTop, setNearTop] = useState(true);
  const [visible, setVisible] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [hovered, setHovered] = useState(null);
  const [focused, setFocused] = useState(null);
  const [leaveStates, setLeaveStates] = useState({});



  useEffect(() => {
    const handleMouseMove = (e) => {
      setNearTop(e.clientY < 80);
    };

    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const atTop = window.scrollY < 80;
      setNearTop(atTop);
      if (isMobile) {
        setVisible(atTop); // only show on top
      }
    };

    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    handleScroll();

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", checkMobile);
    };
  }, [isMobile]);



  return (
    <nav
      aria-label="Main navigation"
      style={{
  padding: "16px 24px",
  textAlign: "center",
  background: nearTop
    ? "#87cefa" // Just a plain sky-blue color
    : "rgba(135, 206, 250, 0.3)",
  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  position: "sticky",
  top: visible ? 0 : "-100%",
  transition: "top 0.5s ease-in-out, background 0.3s ease",
  zIndex: 100,
  backdropFilter: "blur(10px)",
}}

    >
      <ul
        style={{
          listStyle: "none",
          margin: 0,
          padding: 0,
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          maxWidth: 900,
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        {navLinks.map(({ to, label, ariaLabel, tooltip }) => {
          const isHovered = hovered === label;
          const isFocused = focused === label;

          const link = (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => {
                let classNames = "nav-link";
                if (isActive) classNames += " nav-active";
                if (isHovered) classNames += " nav-hover";
                if (isFocused) classNames += " nav-focus";
                if (leaveStates[label]) classNames += " nav-leave";
                return classNames;
              }}
              aria-label={ariaLabel}
              onMouseEnter={() => {
                setHovered(label);
                setLeaveStates(prev => ({ ...prev, [label]: false }));
              }}

              onMouseLeave={() => {
                setHovered(null);
                setLeaveStates(prev => ({ ...prev, [label]: true }));

                setTimeout(() => {
                  setLeaveStates(prev => ({ ...prev, [label]: false }));
                }, 700);
              }}
              onFocus={() => setFocused(label)}
              onBlur={() => setFocused(null)}
            >
              <span>{label}</span>
            </NavLink>
          );


          return (
            <li
              key={to}
              style={{
                marginBottom: 12,
                listStyle: "none",
                display: "inline",
              }}
            >
              {tooltip ? (
                <Tippy
                  content={<span className="tooltip-content">{tooltip}</span>}
                  placement="top"
                  arrow={true}
                  delay={[100, 50]}
                >
                  {link}
                </Tippy>
              ) : (
                link
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Navbar;
